import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { Instagram, Linkedin, Twitter, Github } from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-white border-t border-brand-line/60 pt-20 pb-10 px-5 sm:px-8"
    >
      <div className="max-w-7xl mx-auto">
        {/* Giant wordmark */}
        <div className="mb-14">
          <div className="font-script text-brand text-6xl sm:text-8xl lg:text-9xl leading-none">
            DeFalco
          </div>
          <div className="mt-2 font-display text-brand-muted tracking-[0.4em] text-xs sm:text-sm">
            WEB · SOLUTION · {t.footer.tagline.toUpperCase()}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-10 border-b border-brand-line/60">
          <div className="md:col-span-5">
            <p className="text-brand-muted leading-relaxed max-w-md">
              {t.footer.description}
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[
                { Icon: Instagram, href: "#", label: "Instagram" },
                { Icon: Linkedin, href: "#", label: "LinkedIn" },
                { Icon: Twitter, href: "#", label: "Twitter" },
                { Icon: Github, href: "#", label: "Github" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  data-testid={`social-${label.toLowerCase()}`}
                  className="w-10 h-10 rounded-full border border-brand-line flex items-center justify-center text-brand-muted hover:text-white hover:bg-brand hover:border-brand transition-all"
                >
                  <Icon size={16} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.25em] font-bold text-brand mb-4">
              {t.footer.navTitle}
            </div>
            <ul className="space-y-2 text-sm text-brand-muted">
              {["services", "process", "work", "about", "contact"].map((id) => (
                <li key={id}>
                  <a
                    href={`#${id}`}
                    onClick={scrollTo(id)}
                    className="hover:text-brand transition-colors"
                  >
                    {t.nav[id]}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs tracking-[0.25em] font-bold text-brand mb-4">
              {t.footer.contactTitle}
            </div>
            <ul className="space-y-2 text-sm text-brand-muted">
              <li>
                <a
                  href="mailto:defalcowebsolution@outlook.com"
                  className="hover:text-brand transition-colors"
                >
                  defalcowebsolution@outlook.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+4917621136701"
                  className="hover:text-brand transition-colors"
                >
                  +49 176 21136701
                </a>
              </li>
              <li>Germania · Europa</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs tracking-[0.25em] font-bold text-brand mb-4">
              {t.footer.legalTitle}
            </div>
            <ul className="space-y-2 text-sm text-brand-muted">
              <li><a href="#" className="hover:text-brand transition-colors">{t.footer.legal.privacy}</a></li>
              <li><a href="#" className="hover:text-brand transition-colors">{t.footer.legal.cookies}</a></li>
              <li><a href="#" className="hover:text-brand transition-colors">{t.footer.legal.terms}</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-brand-muted">
          <div>
            © {year} DeFalco WebSolution · {t.footer.rights}
          </div>
          <div>{t.footer.madeIn}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
